/**
 * The one age formatter. A review queue is read in minutes, so "today" (the
 * console's old granularity) is not enough — but a queue is also glanced at, so
 * nothing gets a second unit. Always rounds DOWN: a row may never claim to be
 * older than it is.
 */
const MINUTE = 60_000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

export function formatAge(from: Date | number, now: Date | number = Date.now()): string {
  const elapsed = Number(now instanceof Date ? now.getTime() : now)
    - Number(from instanceof Date ? from.getTime() : from);
  if (!Number.isFinite(elapsed) || elapsed < MINUTE) return "now";
  if (elapsed < HOUR) return `${Math.floor(elapsed / MINUTE)}m`;
  if (elapsed < DAY) return `${Math.floor(elapsed / HOUR)}h`;
  return `${Math.floor(elapsed / DAY)}d`;
}
